module.exports = __webpack_public_path__ + "img/planet.3201f295.png";